import { render, staticRenderFns } from "./_purchases.vue?vue&type=template&id=98b417dc&scoped=true&"
import script from "./_purchases.vue?vue&type=script&lang=js&"
export * from "./_purchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b417dc",
  null
  
)

export default component.exports